/**
 * What: "Data and privacy" and "Support and resources" sections of the Settings page.
 *   SettingsPagePolaris.tsx's cards no longer wrap themselves in their own <s-section> — they're
 *   only ever used nested in one here.
 * Transport / data-flow: Pure presentation, no props.
 */
import { productLanguage } from '@testfeed/product-language'
import { DataSafetyPrivacyCardPolaris, SupportResourcesCardPolaris } from '../../SettingsPagePolaris'

export function PrivacySupportSection() {
  const copy = productLanguage.shopify.components.shopifySettingsContent
  return (
    <>
      <s-section heading={copy.privacySectionTitle}>
        <s-text color="subdued">{copy.privacySectionDescription}</s-text>
        <DataSafetyPrivacyCardPolaris />
      </s-section>
      <s-section heading={copy.supportSectionTitle}>
        <s-text color="subdued">{copy.supportSectionDescription}</s-text>
        <SupportResourcesCardPolaris />
      </s-section>
    </>
  )
}
